import React, { useState } from "react";
import styled from "styled-components";
import { stayUpdated } from "../../services/stay-updated.js";
import Input from "../library/Input.js";
import ButtonStyled from "../../components/library/Button.js";
import { navigate } from "gatsby";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import addToMailchimp from "gatsby-plugin-mailchimp";

const StayUpdated = ({ isModal = false }) => {
  const [result, setResult] = useState(null);

  const submitForm = async (values) => {
    const res = await addToMailchimp(values.email, {
      company: values.company,
      FNAME: values.name,
    });
    setResult(res.result);
  };

  // const submitForm =  async (values) => {
  //     try {
  //         const val = {
  //             fullname: values.name,
  //             company: values.company,
  //             email: values.email
  //         }
  //         await stayUpdated(val);
  //         setResult("success");
  //         // navigate('/confirmation-newsletter')
  //     } catch (e) {
  //         console.log("E", e);
  //         setResult("error");
  //     }
  // }

  return (
    <StayUpdatedStyle id={"stay-updated"} isModal={isModal}>
      <Left isModal={isModal}>
        <Title isModal={isModal}>Stay Updated</Title>
        <Description isModal={isModal}>
          Receive the latest from Medad Technology—subscribe here for updates on
          our HealthTech solutions and advancements.
        </Description>
      </Left>
      <Right isModal={isModal}>
        <Formik
          enableReinitialize
          initialValues={{
            name: "",
            email: "",
            company: "",
          }}
          validationSchema={Yup.object({
            name: Yup.string().required("Field required"),
            email: Yup.string()
              .email("Must be an email")
              .required("Field required"),
            company: Yup.string().required("Field required"),
          })}
          onSubmit={(values, { setSubmitting }) => {
            console.log("VALUES", values);
            submitForm(values);
          }}
        >
          {(props) => (
            <Form>
              <Input
                name={"name"}
                id={"name"}
                placeholder={"Full name*"}
                type={"text"}
              />
              <Input
                name={"email"}
                id={"email"}
                placeholder={"Email*"}
                type={"email"}
                className={"email"}
              />
              <Input
                name={"company"}
                id={"company"}
                placeholder={"Company name*"}
                type={"text"}
                className={"company"}
              />
              <Button>
                {result === "success" && (
                  <Success>
                    <p>Thank you, message sent !</p>
                  </Success>
                )}
                {result === "error" && (
                  <Success>
                    <p>Good news, your email is already registered!</p>
                  </Success>
                )}
                <div></div>
                <ButtonStyled primary type={"submit"} label={"Submit"} />
              </Button>
            </Form>
          )}
        </Formik>
      </Right>
    </StayUpdatedStyle>
  );
};

const StayUpdatedStyle = styled.div`
  max-width: ${({ isModal }) => (isModal ? "54.3rem" : "unset")};
  padding: ${({ isModal }) => (isModal ? "0rem" : "10rem 12rem 6rem 12rem")};
  min-height: ${({ isModal }) => (isModal ? "auto" : "70vh")};
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 15rem;
  color: ${({ theme }) => theme.colors.primary};
  justify-content: center;
  align-content: center;
  align-items: center;
  display: ${({ isModal }) => (isModal ? "flex" : "grid")};
  flex-direction: ${({ isModal }) => (isModal ? "column" : "")};
  @media ${({ theme }) => theme.breakpoints.mobile} {
    min-height: ${({ isModal }) => (isModal ? "auto" : "unset")};
    display: flex;
    flex-direction: column;
    padding: ${({ isModal }) =>
      isModal ? "0rem" : "0rem 2.4rem 4.4rem 2.4rem"};
    gap: ${({ isModal }) => (isModal ? "0" : "0rem")};
  }
  @media ${({ theme }) => theme.breakpoints.small_height} {
    padding: ${({ isModal }) => (isModal ? "0rem" : "10rem 15vw 6rem 15vw")};
    min-height: ${({ isModal }) => (isModal ? "auto" : "none")};
  }
`;

const Success = styled.div`
  display: flex;
  align-items: center;
  margin-right: 3rem;
  padding: 1rem 0rem;
  color: #53976f;
`;

const Error = styled.div`
  display: flex;
  align-items: center;
  margin-right: 3rem;
  padding: 1rem 0rem;
  color: #df3b3b;
`;

const Left = styled.div`
  align-self: flex-start;
  margin-top: 2.5rem;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    margin-top: ${({ isModal }) => (isModal ? ".4rem" : "2.5rem")};
  }
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    padding: ${({ isModal }) => (isModal ? "0rem" : "0rem 0rem")};
  }
`;

const Title = styled.h2`
  font-size: 3.2rem;
  display: flex;
  flex-direction: column;
  text-align: ${({ isModal }) => (isModal ? "center" : "left")};
  @media ${({ theme }) => theme.breakpoints.mobile} {
    font-size: 2rem;
    text-align: left;
  }
`;

const Description = styled.p`
  padding: ${({ isModal }) => (isModal ? "2.4rem 0" : "3.2rem 0")};
  font-family: ${({ theme }) => theme.fonts.sequel45};
  font-size: 2rem;
  text-align: ${({ isModal }) => (isModal ? "center" : "left")};
  @media ${({ theme }) => theme.breakpoints.mobile} {
  }
  //max-width: 54.3rem;

  span {
    display: block;
  }

  @media ${({ theme }) => theme.breakpoints.mobile} {
    font-size: 1.6rem;
    padding-bottom: ${({ isModal }) => (isModal ? "0" : "3.2rem")};
    text-align: left;
  }
`;

const Button = styled.div`
  margin-top: 3.7rem;
  display: flex;
  justify-content: space-between;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    flex-direction: column;
  }
`;

export default StayUpdated;
